import { Optional } from "common/utils/types";

import { DiscountBreakdown } from "./carts";

export const PriceSummaryItemKind = {
  Subtotal: "subtotal",
  Shipping: "shipping",
  ClientHandlingFees: "client_handling_fees",
  ClientPurchasingFee: "client_purchasing_fee",
  Discount: "discount",
  Tax: "tax",
  Total: "total",
} as const;
export type PriceSummaryItemKind = (typeof PriceSummaryItemKind)[keyof typeof PriceSummaryItemKind];

/** All fields supported by our centralized price summary component */
export interface PriceSummary {
  subtotal: number;
  client_handling_fees: number;
  client_purchasing_fee?: number;
  discount: number;
  total: number;
  discount_breakdown?: DiscountBreakdown[];
  shipping?: Optional<number>;
  tax?: Optional<number>;
  total_discount_label?: string;
  total_label?: string;
  subtotal_label?: string;
  is_tax_final?: boolean;
  is_shipping_final?: boolean;
  is_shipping_free?: boolean;
  is_all_pickup?: boolean;
  include_tax_if_unset?: boolean;
}

/** Required fields for order price summaries */
export interface OrderPriceSummary extends PriceSummary {
  shipping: number;
  tax: number;
  is_all_pickup: boolean;
}

/** required fields for cart price summaries */
export interface CartPriceSummary extends PriceSummary {
  discount_breakdown: DiscountBreakdown[];
  is_all_pickup: boolean;
}

/** Required fields for subscription price summaries */
export interface SubscriptionPriceSummary extends PriceSummary {}
